<template>
  <div>
    <v-card style="padding: 20px">
      <v-form ref="form">
        <v-card-title>Set Overlay Position</v-card-title>
        <v-form ref="form"
                v-model="topAndLeftValid"
        >
          <v-card-text>
            <div class="row row--space-between selectInput">
              <v-select :items="aspectRatios"
                        item-value="ratioValue"
                        item-text="ratioName"
                        v-model="aspectRatioValue"
                        @change="updateAspectRatio()"
                        label="Video Aspect Ratio"
              ></v-select>
            </div>
            <div class="row row--space-between">
              <div class="textFieldInput">
                <v-text-field
                  v-model.number="localTop"
                  label="Top overlay position"
                  :rules="[rules.notANumber]"
                  type="number"
                ></v-text-field>
              </div>
              <div class="textFieldInput">
                <v-text-field
                  v-model.number="localLeft"
                  label="Left overlay position"
                  :rules="[rules.notANumber]"
                  type="number"
                ></v-text-field>
              </div>
            </div>
            <v-responsive :aspect-ratio="vResponsiveRatioValue"
                          class="mt-3"
                          :width="parentWidth"
                          style="border: 1px solid white"
            >
              <div style="width:100%"
                   ref="vresponsive"
              >
                <VueDragResize
                  :w="localWidth"
                  :h="localHeight"
                  :x="localLeft"
                  :y="localTop"
                  :parentW="parentWidth"
                  :parentH="parentWidth/aspectRatioValue"
                  :aspectRatio="true"
                  @resizing="resize"
                  @dragging="drag"
                  :sticks="['tl','tr','br','bl']"
                  :parentLimitation="true"
                >
                  <img :src="overlayImgSrcType + localFileContent"
                       class="overlay"
                  >
                </VueDragResize>
              </div>
            </v-responsive>
          </v-card-text>
        </v-form>
        <v-spacer></v-spacer>
        <v-card-actions>
          <div class="row row--end">
            <v-btn text
                   @click="$emit('cancel')"
            >Cancel </v-btn>
            <v-btn
              text
              color="primary"
              @click="updateDimensions()"
            >
              Set position
            </v-btn>
          </div>
        </v-card-actions>
      </v-form>
    </v-card>
  </div>
</template>

<script>
import VueDragResize from 'vue-drag-resize'

export default {
  name:       "OverlayPositionForm",
  components: {
    VueDragResize
  },
  props: {
    overlay: Object
  },
  data: function() {
    return {
      topAndLeftValid:       false,
      localFileContent:      undefined,
      localTop:              0,
      localLeft:             0,
      localWidth:            0,
      localHeight:           0,
      parentWidth:           1000,
      aspectRatioValue:      (16/9),
      vResponsiveRatioValue: 16/9,
      overlayImgSrcType:     'data:image/svg+xml;base64,',
      rules:                 {
        notANumber: (value) => !isNaN(value) || "Number required",
      },
      aspectRatios: [
        {
          ratioValue:       (3/2),
          ratioName:        "3 : 2",
          vResponsiveRatio: 3/2
        },
        {
          ratioValue:       (4/3),
          ratioName:        "4 : 3",
          vResponsiveRatio: 4/3
        },
        {
          ratioValue:       (5/4),
          ratioName:        "5 : 4",
          vResponsiveRatio: 5/4
        },
        {
          ratioValue:       (16/9),
          ratioName:        "16 : 9",
          vResponsiveRatio: 16/9
        },
        {
          ratioValue:       (16/10),
          ratioName:        "16 : 10",
          vResponsiveRatio: 16/10
        },
        {
          ratioValue:       (21/9),
          ratioName:        "21 : 9",
          vResponsiveRatio: 21/9
        }
      ]
    }
  },
  created() {
    const overlayTopRatio = parseFloat(JSON.parse(JSON.stringify(this.overlay.topRatio)));
    const overlayLeftRatio = parseFloat(JSON.parse(JSON.stringify(this.overlay.leftRatio)));
    const overlayWidthRatio = JSON.parse(JSON.stringify(this.overlay.widthRatio));
    const overlayOriginalWidth = JSON.parse(JSON.stringify(this.overlay.originalWidth));
    const overlayOriginalHeight = JSON.parse(JSON.stringify(this.overlay.originalHeight));
    this.aspectRatioValue = JSON.parse(JSON.stringify(this.overlay.aspectRatio));
    this.updateAspectRatio();

    this.localTop = Math.floor(overlayTopRatio == 0 ? 0 : overlayTopRatio * (this.parentWidth / this.aspectRatioValue));
    this.localLeft = Math.floor(overlayLeftRatio == 0 ? 0 : overlayLeftRatio * this.parentWidth);
    this.localWidth = overlayWidthRatio == 0 ? overlayOriginalWidth : overlayWidthRatio * this.parentWidth;

    const localWidthToOriginalRatio = this.localWidth / overlayOriginalWidth;
    this.localHeight = overlayOriginalHeight * localWidthToOriginalRatio;
    this.localFileContent = JSON.parse(JSON.stringify(this.overlay.fileContent));

    this.overlayImgSrcType = this.overlay.type == 'Svg' ? 'data:image/svg+xml;base64,' : 'data:image/png;base64,'
  },
  methods: {
    resize(newRect) {
      this.localWidth = newRect.width;
      this.localHeight = newRect.height;
      this.localTop = newRect.top;
      this.localLeft = newRect.left;
    },
    drag(newRect) {
      this.localTop = newRect.top;
      this.localLeft = newRect.left;
    },
    updateDimensions() {
      const parentWidth = this.$refs.vresponsive.clientWidth;
      const parentHeight = (parentWidth / this.aspectRatioValue);
      const leftRatio = this.localLeft / parentWidth;
      const topRatio = this.localTop / parentHeight;
      const widthRatio = this.localWidth / parentWidth;
      this.$emit('updateOverlayPosition', leftRatio, topRatio, widthRatio, this.aspectRatioValue);
    },
    updateAspectRatio() {
      const selectedRatio = this.aspectRatios.filter(x => x.ratioValue == this.aspectRatioValue);
      this.vResponsiveRatioValue = selectedRatio[0].vResponsiveRatio;
    }
  }
};
</script>

<style scoped>
  .handle {
    cursor: all-scroll;
  }
  .overlay {
    width: 100%;
    height: 100%;
    background : url(
    data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAoAAAAKCAYAAACNMs+9AAAAKElEQVQoU2NctWrVfwY0oKSkhC7EwDgUFJ45cwbDM/fu3cP0zBBQCACDvi7rftyl7QAAAABJRU5ErkJggg==
    ) repeat;
  }
  .textFieldInput {
    width: 48%
  }
  .selectInput {
    width: 20%
  }
</style>
